<template>
  <a class="h-12 flex items-center justify-start underline cursor-pointer" @click='gotoUser'>
    <img v-if='user.username === "anonymous"' src="/img/PBC_Icon_LatestQuestions.png" alt="" class="object-contain w-4 mr-1">
    <img v-else src="/img/PBC_Meme.svg" alt="" class="object-contain w-4 mr-1">
    <p class="w-12 md:w-auto text-sm truncate">{{user.username}}</p>
    <slot name='default' />
  </a>
</template>
<script>
export default {
  props:{
    user:{
      type:Object,
      default() {
        return {
          username: 'anonymous',
          avatarImage: 'placeholder.png'
        }
      }
    }
  },
  methods:{
    gotoUser() {
      this.$router.push({
        name:'userposts',
        params:{
          username:this.user.username
        }
      });
    }
  }

}
</script>
